export default "__VITE_ASSET__buj4c0Xt__"